/**
 * Top-level layout for the printed report.
 */

import type { Card, CheckSummary, VerdictCode } from '@eloquor/api-contract';
import { groupCardsByArgument } from '../textUtils';
import { ReportArgumentGroup } from './ReportArgumentGroup';

export interface ReportMainProps {
  cards: Card[];
  summary: CheckSummary;
  generatedAt?: Date;
}

const verdictKeys: VerdictCode[] = [
  'ok',
  'ethicsvio',
  'miscut',
  'powertagged',
  'unclear',
  'error',
  'unchecked',
];

export function ReportMain({ cards, summary, generatedAt = new Date() }: ReportMainProps) {
  const groups = groupCardsByArgument(cards);
  return (
    <div>
      <h1 className="report-h1">Eloquor — evidence report</h1>
      <p className="report-meta">
        {cards.length} cards · generated {generatedAt.toLocaleString()}
      </p>

      <div className="report-summary">
        <span>Total {summary.total}</span>
        {verdictKeys.map((v) =>
          summary[v] > 0 ? (
            <span
              key={v}
              style={{
                color: `var(--rt-${v}-ink)`,
                background: `var(--rt-${v}-soft)`,
                border: `1px ${v === 'unchecked' ? 'dashed' : 'solid'} var(--rt-${v})`,
              }}
            >
              {v} {summary[v]}
            </span>
          ) : null
        )}
      </div>

      {groups.map((g) => (
        <ReportArgumentGroup key={g.key} group={g} />
      ))}
    </div>
  );
}
